import { render, staticRenderFns } from "./sealConfirm.vue?vue&type=template&id=2c632290&scoped=true"
import script from "./sealConfirm.vue?vue&type=script&lang=js"
export * from "./sealConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c632290",
  null
  
)

export default component.exports